<template>
  <div>
    <div class="loading" v-show="loading">
      <i class="fa fa-circle-notch fa-spin"></i>
      <span>{{ $t('rsvpDetails.notes.loading') }}</span>
    </div>

    <div class="empty-state" v-show="notes.length === 0 && !loading">
      <i class="fa fa-address-card fa-4x"></i>
      <span>{{ $t('rsvpDetails.notes.emptyState') }}</span>
    </div>

    <div class="note" v-for="note in notes">
      <div class="user">
        <div class="img-holder">
          <img :src="note.picture" />
        </div>
        <span class="name">{{ note.name }}</span>
        <span class="date">{{ note.date }}</span>
      </div>

      <div class="note-content">
        <div class="arrow"></div>
        <p v-html="note.message"></p>
        <div class="actions">
          <div v-if="adminId === note.userId">
            <span @click="editNote(note)">{{ $t('rsvpDetails.notes.edit') }}</span> |
            <span @click="deleteNote(note)">{{ $t('rsvpDetails.notes.delete') }}</span>
          </div>
          <label v-bind:class="['status', note.status]">{{ note.status }}</label>
        </div>
      </div>

      <div :class="{'delete-block':true, 'show':noteDeleteId === note.id}">
        <div :class="{'content':true, 'disabled':deleteLoading}">
          <p>
            {{ $t('rsvpDetails.notes.deleteMessage') }}
            <span v-show="!!deleteMessage">
              <br /> {{ deleteMessage }}
            </span>
          </p>
          <a class="button cta warning small" @click="hideDelete">{{ $t('rsvpDetails.notes.no') }}</a>
          <a class="button cta success small" @click="deleteConfirm(note.id)">
            <span v-show="!deleteLoading">{{ $t('rsvpDetails.notes.yes') }}</span>
            <i class="fa fa-spinner fa-spin fa-fw" v-show="deleteLoading"></i>
          </a>
        </div>
      </div>
    </div>

    <div class="note-mobile" v-for="note in notes">

      <div class="note-content">
        <div class="user">
          <div class="img-holder">
            <img :src="note.picture" />
          </div>
          <div class="details">
            <span class="name">{{ note.name }}</span>
            <span class="date">{{ note.date }}</span>
          </div>
        </div>
        <p v-html="note.message"></p>
        <div class="actions">
          <div v-if="adminId === note.userId">
            <span @click="editNote(note)">{{ $t('rsvpDetails.notes.edit') }}</span> |
            <span @click="deleteNote(note)">{{ $t('rsvpDetails.notes.delete') }}</span>
          </div>
          <label v-bind:class="['status', note.status]">{{ note.status }}</label>
        </div>
      </div>

      <div :class="{'delete-block':true, 'show':noteDeleteId === note.id}">
        <div :class="{'content':true, 'disabled':deleteLoading}">
          <p>
            {{ $t('rsvpDetails.notes.deleteMessage') }}
            <span v-show="!!deleteMessage">
              <br /> {{ deleteMessage }}
            </span>
          </p>
          <a class="button cta warning small" @click="hideDelete">{{ $t('rsvpDetails.notes.no') }}</a>
          <a class="button cta success small" @click="deleteConfirm(note.id)">
            <span v-show="!deleteLoading">{{ $t('rsvpDetails.notes.yes') }}</span>
            <i class="fa fa-spinner fa-spin fa-fw" v-show="deleteLoading"></i>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ApiRsvp from '../../modules/api/reservations'

export default {
  name: 'notes',
  props: ['rsvpId'],
  data () {
    return {
      loading: false,
      deleteLoading: false,
      deleteMessage: ''
    }
  },
  computed: {
    notes () {
      return this.$store.state.rsvpDetails.notes.list
    },
    adminId () {
      return this.$store.state.session.user.id
    },
    noteDeleteId () {
      return this.$store.state.rsvpDetails.notes.noteDeleteId
    }
  },
  methods: {
    init () {
      let self = this
      self.loading = true
      self.$store.commit('rsvpDetails/resetNotes')
      ApiRsvp.getNotesByRsvpId(self, self.rsvpId, function (res) {
        self.loading = false
      })
    },
    editNote (value) {
      this.$store.commit('reservationNotes/show', {
        noteId: value.id,
        notes: value.message,
        noteStatus: value.status
      })
    },
    deleteNote (value) {
      this.$store.commit('rsvpDetails/setNoteDeleteId', value.id)
      this.deleteMessage = ''
    },
    hideDelete () {
      this.$store.commit('rsvpDetails/setNoteDeleteId', 0)
    },
    deleteConfirm (noteId) {
      let self = this
      self.deleteLoading = true
      self.deleteMessage = ''
      ApiRsvp.deleteNote(self, noteId, function (res) {
        if (res.error) {
          self.deleteMessage = res.error.msg
        }
        self.deleteLoading = false
      })
    }
  },
  watch: {
    rsvpId: function (value) {
      this.init()
    }
  },
  mounted () {
    this.init()
  }
}
</script>

<style lang="scss" scoped>
$cta-link: #0D79F2;

.loading{
  text-align: center;
  padding: 30px;
  font-size: 18px;

  .fa{
    margin-right: 5px;
    color: #555;
  }
  span{ color: #888; }
}

.empty-state{
  padding: 30px;
  font-size: 18px;
  color: #999;
  text-align: center;

  .fa{
    display: block;
    margin-bottom: 5px;
    color: #ddd;
  }
}

.note{
  display: flex;
  padding: 10px 20px;
  position: relative;
}

.user{
  text-align: center;
  width: 170px;
  padding: 0 10px;
  display: inline-block;
  vertical-align: top;
  position: relative;
  z-index: 1;

  .img-holder{
    width: 75px;
    height: 75px;
    border-radius: 100%;
    overflow: hidden;
    display: inline-block;
  }
  span{ display: block; }
  .name{
    font-weight: 600;
    font-size: 14px;
    color: #555;
  }
  .date{
    font-size: 11px;
    color: #999;
  }
}

.note-content{
  background: #f5f5f5;
  padding: 15px;
  display: inline-block;
  width: calc(100% - 170px);
  /*min-height: 100px;*/
  position: relative;
  z-index: 2;
  border-radius: 2px;
  box-shadow: 0 0 3px 1px rgba(0,0,0, .2);

  .arrow{
    position: absolute;
    z-index: 2;
    top: 30px;
    right: 100%;
    margin-right: -20px;
    width: 20px;
    height: 20px;
    background: #f5f5f5;
    box-shadow: -2px 2px 1px rgba(0,0,0, .15);
    transform: translate(-50%, 0) rotate(45deg);
  }
  .status{
    font-size: 10px;
    font-weight: 600;
    padding: 2px 7px;
    color: #fff;
    text-transform: uppercase;
    border-radius: 4px;
    font-style: italic;
    float: left;

    &.resolved{ background: #26D97A }
    &.investigation{ background: #F25E0D }
    &.new{ background: #F20D0D }
  }
  p{
    position: relative;
    z-index: 3;
    font-size: 13px;
    margin: 0;
    color: #555;
    min-height: 60px;
    word-wrap: break-word;
  }
  .actions{
    text-align: right;
    font-size: 12px;
    margin-top:10px;
    font-weight: 600;

    span{
      color: $cta-link;
      display: inline-block;
      margin: 0 2px;
      cursor: pointer;
    }
  }
}

.delete-block{
  position: absolute;
  top: 50%;
  right: 0;
  width: 100%;
  height: 0%;
  visibility: hidden;
  z-index: 2;
  text-align: center;
  overflow: hidden;
  transition: background .2s, height .2s, top .2s;

  .content{
    display: none;
    p{
      color: #fff;
      font-weight: 600;

      span{
        color: #ff1b1b;
        font-style: italic;
      }
    }
    .button{
      min-width: 100px;
      margin: 0 5px;
      display: inline-block;
    }
    &.disabled .button{
      opacity: .5;
      cursor: default;
      font-weight: 100;
      color: #f00;
    }
  }
  &.show{
    visibility: visible;
    background: rgba(0,0,0, .8);
    height: 100%;
    top: 0;

    .content{ display: block; }
  }
}

.note-mobile {
  display: none;
}

@media only screen and (max-width: 430px) {
  .note {
    display: none;
  }

  .note-mobile {
    display: block;
    padding: 8px 15px;
    position: relative;
    .note-content {
      width: 100%;
      .user {
        display: flex;
        width: 100%;
        padding: 0;
        align-items: center;
        gap: 5px;
        margin-bottom: 5px;

        .img-holder {
          width: 50px;
          height: 50px;
        }

        .details {
          text-align: left;
        }

      }

      .actions {
        display: flex;
        justify-content: space-between;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/RsvpDetails/Notes.vue